import {
    Button
} from 'shared/components/ui/button';
import {
    Edit, Trash2
} from 'lucide-react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from 'shared/components/ui/alert-dialog';

export function ApiList({
    apis, onSelect, onEdit, onDelete, selectedId
}) {
    if (apis.length === 0) {
        return (
            <div className="border border-dashed rounded-md p-6 text-center">
                <p className="text-muted-foreground text-sm">No APIs saved yet</p>
            </div>
        );
    }

    return (
        <div className="border rounded-md overflow-hidden">
            <div className="h-[500px] overflow-y-auto">
                {apis.map((api) => (
                    <div
                        key={api._id}
                        className={`p-3 flex justify-between items-center hover:bg-muted/50 cursor-pointer ${
                            api._id === selectedId ? 'bg-muted' : ''
                        }`}
                        onClick={() => onSelect(api)}
                    >
                        <div className="truncate">
                            <div className="font-medium truncate">{api.name || 'Unnamed API'}</div>
                            <div className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                                <span className="px-1.5 py-0.5 bg-primary/10 text-primary text-[10px] font-bold rounded">
                                    {api.method}
                                </span>
                                <span className="truncate">{api.url}</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-1 ml-2">
                            <Button
                                variant="ghost"
                                size="icon"
                                className="h-7 w-7"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit(api);
                                }}
                            >
                                <Edit className="h-4 w-4" />
                            </Button>

                            <AlertDialog>
                                <AlertDialogTrigger asChild>
                                    <Button
                                        variant="ghost"
                                        size="icon"
                                        className="h-7 w-7 text-destructive hover:text-destructive"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <Trash2 className="h-4 w-4" />
                                    </Button>
                                </AlertDialogTrigger>
                                <AlertDialogContent>
                                    <AlertDialogHeader>
                                        <AlertDialogTitle>Delete API</AlertDialogTitle>
                                        <AlertDialogDescription>
                                            Are you sure you want to delete "{api.name || 'Unnamed API'}"? This action cannot be undone.
                                        </AlertDialogDescription>
                                    </AlertDialogHeader>
                                    <AlertDialogFooter>
                                        <AlertDialogCancel>Cancel</AlertDialogCancel>
                                        <AlertDialogAction
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onDelete(api._id);
                                            }}
                                            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                                        >
                                            Delete
                                        </AlertDialogAction>
                                    </AlertDialogFooter>
                                </AlertDialogContent>
                            </AlertDialog>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
